export default __webpack_public_path__ + "static/media/rating.78573a12.svg";